import { render, staticRenderFns } from "./donors.vue?vue&type=template&id=de848a2c&scoped=true&"
import script from "./donors.vue?vue&type=script&lang=js&"
export * from "./donors.vue?vue&type=script&lang=js&"
import style0 from "./donors.vue?vue&type=style&index=0&id=de848a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de848a2c",
  null
  
)

export default component.exports